import React from "react";
import {
  Box,
  Grid,
  Text,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import NavCard from "../../../components/navcard";
import useQualityimprovementTabs from "../../../utils/data/QiTabs";
import Title from "../../../components/Title";
import useQIProjectMenuItems from "../../../utils/data/QIProjectMenuItems";

const Qualityimprovement = () => {
  const Menu = useQIProjectMenuItems();
  const QiTabs = useQualityimprovementTabs();
  const navigate = useNavigate();
  return (
    <Box
      display={"flex"}
      w={"100%"}
      h={"100%"}
      flexDirection={"column"}
      justifyContent={"flex-start"}
      alignItems={"center"}
      alignContent={"flex-start"}
      textAlign={"left"}
    >
      <Grid
        w={"70%"}
        templateColumns={["repeat(1, 1fr)"]}
        flexDirection={"column"}
        gridGap={50}
      >
        <Box style={{ gridColumn: "1 / -1" }}>
          <Title
            title={"Quality Improvement"}
            onClick={() => {
              navigate("/");
            }}
          />
          <Text fontWeight={500} alignSelf={"center"} justifySelf={"center"} mt={30}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. ad minim veniam, quis nostrud
            exercitation ullamco laboris nisi ut aliquip ex ea commodo
            consequat.
          </Text>
        </Box>
        <Grid
          h={"100%"}
          w={"70%"}
          mt={10}
          alignSelf={"center"}
          justifySelf={"center"}
          // bgColor={"red"}
          templateColumns={[
            "repeat(1, 1fr)",
            "repeat(2, 1fr)",
            "repeat(3, 1fr)",
            "repeat(4, 1fr)",
          ]}
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"center"}
          alignContent={"center"}
          alignItems={"center"}
          gap={[4, 4, 5, 5, 10, 20]}
        >
          {Menu.map((item) => (
            <NavCard
              icon={item.icon}
              title={item.title}
              width={"50%"}
              height={"200px"}
              onClick={item.onClick}
            />
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default Qualityimprovement;
